/**
 * Copyright IBM Corp. 2016, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { objectWithoutProperties as _objectWithoutProperties, defineProperty as _defineProperty, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React__default from 'react';
import cx from 'classnames';
import { usePrefix } from '../../internal/usePrefix.js';

var _span, _span2, _span3;

var _excluded = ["rowCount", "border", "className"];

var StructuredListSkeleton = function StructuredListSkeleton(_ref) {
  var _cx;

  var rowCount = _ref.rowCount,
      border = _ref.border,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var prefix = usePrefix();
  var StructuredListSkeletonClasses = cx(className, (_cx = {}, _defineProperty(_cx, "".concat(prefix, "--skeleton"), true), _defineProperty(_cx, "".concat(prefix, "--structured-list"), true), _defineProperty(_cx, "".concat(prefix, "--structured-list--border"), border), _cx));
  var rows = [];

  for (var i = 0; i < rowCount; i++) {
    rows.push( /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(prefix, "--structured-list-row"),
      key: i
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(prefix, "--structured-list-td")
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(prefix, "--structured-list-td")
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(prefix, "--structured-list-td")
    })));
  }

  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: StructuredListSkeletonClasses
  }, rest), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefix, "--structured-list-thead")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefix, "--structured-list-row ").concat(prefix, "--structured-list-row--header-row")
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefix, "--structured-list-th")
  }, _span || (_span = /*#__PURE__*/React__default.createElement("span", null))), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefix, "--structured-list-th")
  }, _span2 || (_span2 = /*#__PURE__*/React__default.createElement("span", null))), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefix, "--structured-list-th")
  }, _span3 || (_span3 = /*#__PURE__*/React__default.createElement("span", null))))), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(prefix, "--structured-list-tbody")
  }, rows));
};

StructuredListSkeleton.propTypes = {
  /**
   * Specify whether a border should be added to your StructuredListSkeleton
   */
  border: PropTypes.bool,

  /**
   * Specify an optional className to add.
   */
  className: PropTypes.string,

  /**
   * number of table rows
   */
  rowCount: PropTypes.number
};
StructuredListSkeleton.defaultProps = {
  rowCount: 5,
  border: false
};
var StructuredListSkeleton$1 = StructuredListSkeleton;

export { StructuredListSkeleton$1 as default };
